const LOGIN_EVENT = 'spot.im.social.login';
const CANCELLED_EVENT = 'spot.im.social.login.cancelled';

export default { LOGIN_EVENT, CANCELLED_EVENT };
